// btw-front/src/components/ui/StatCard.jsx
import React from "react";

export function StatCard({ label, value, hint, accent = false, className = "" }) {
  return (
    <div
      className={`flex flex-col gap-1 rounded-xl border bg-white p-4 ${
        accent ? "border-accent/30 bg-accent/[0.04]" : "border-slate-200"
      } ${className}`}
    >
      <div className="text-xs font-medium text-slate-500">{label}</div>
      <div className="text-2xl font-bold tracking-tight text-slate-900 tabular-nums">{value}</div>
      {hint && <div className="text-[11px] text-slate-400">{hint}</div>}
    </div>
  );
}
